import {SelectInputItem} from '../components/inputs/SelectInput'

export interface HasCode {
  code: string
}

export interface NamedApiItem extends HasCode {
  name: string
}

export const idExtractor = (data: HasCode) => data.code

export const selectItemMapper = (data: NamedApiItem): SelectInputItem => ({
  label: data.name,
  value: data.code,
})
